import { useMemo } from "react";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import FactoryIcon from "@mui/icons-material/Factory";
import GroupsIcon from "@mui/icons-material/Groups";
import PeopleIcon from "@mui/icons-material/People";
import TrainIcon from "@mui/icons-material/Train";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import VerifiedIcon from "@mui/icons-material/Verified";
import { useLocation } from "react-router";
import { useListTenantGroupsQuery } from "src/store/api/generatedApi";
import { MenuItem } from "./types";

const MISSION_CONTROL_PATH = "/mission-control";

const STATIC_ITEMS: MenuItem[] = [
  {
    path: MISSION_CONTROL_PATH,
    i18nKey: "mills",
    icon: <FactoryIcon />,
  },
  {
    path: "/logistics",
    i18nKey: "logistics",
    icon: <TrainIcon />,
    requireAdmin: true,
  },
  {
    path: "/scrap-eye/labelling-coverage",
    i18nKey: "labellingCoverage",
    icon: <VerifiedIcon />,
    requireAdmin: true,
  },
  {
    path: "/scrap-eye/labelling-cost",
    i18nKey: "labellingCostOverview",
    icon: <MonetizationOnIcon />,
    requireAdmin: true,
  },
  {
    path: "/scrap-eye/manage-labellers",
    i18nKey: "labellerStats",
    icon: <GroupsIcon />,
    requireAdmin: true,
  },
  {
    path: "/scrap-eye/review-data",
    i18nKey: "reviewData",
    icon: <TrackChangesIcon />,
    requireAdmin: true,
  },
];

export const useMultiTenantMenuItems = (): MenuItem[] => {
  const { data } = useListTenantGroupsQuery();
  const location = useLocation();
  const tenantGroupNames = useMemo(
    () => data?.tenant_group_names ?? [],
    [data?.tenant_group_names]
  );
  const tenantGroupLongNames = useMemo(
    () => data?.tenant_group_long_names ?? {},
    [data?.tenant_group_long_names]
  );

  const showAdminMenu = location.pathname === MISSION_CONTROL_PATH;

  return useMemo(
    () => [
      ...STATIC_ITEMS,
      ...(tenantGroupNames.length > 0 && showAdminMenu
        ? [
            {
              path: "/admin",
              i18nKey: "admin",
              icon: <AdminPanelSettingsIcon />,
              requireAdmin: true,
              children: tenantGroupNames.map((name) => ({
                path: `/o/${name}/admin/users`,
                label: tenantGroupLongNames[name] ?? name,
                i18nKey: "manageUsers",
                icon: <PeopleIcon />,
                requireAdmin: true,
              })),
            },
          ]
        : []),
    ],
    [tenantGroupNames, tenantGroupLongNames, showAdminMenu]
  );
};
